import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

// 主题色值
export const theme = {
  primary: "#2563eb", // 蓝色主色调
  primaryLight: "#3b82f6",
  primaryDark: "#1d4ed8",
  secondary: "#64748b",
  accent: "#0ea5e9",
  background: "#f8fafc",
  text: "#1e293b",
};

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};
